import React, { Component } from "react";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import Paper from "@material-ui/core/Paper";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Preview.css";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import DownloadLink from "./../../../util/downloader/DownloadLink";
import { Grid, Divider, Box, AppBar, Tabs, Tab, Chip } from "@material-ui/core";
// import trackFields from "../../../_module/definition/trackFields";
import clsx from "clsx";
import { _PermittedSetting } from "../../../_module/utils/PermittedSetting";
import moment from "moment";
import trackColumns from "../../ml-music-search/track/Columns";
import albumColumns from "../../ml-music-search/album/Columns";
import { ColumnTypes } from "../../../util/table-view/TableTypes";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import TextElement from "../../../util/preview-element/TextElement";
import OrgUserPlaylistSharedUsers from "../../../util/preview-element/OrgUserPlaylistSharedUsers";
import DateTimeElement from "../../../util/preview-element/DateTimeElement";
import {
  MigratedPlaylistTypesList,
  PlaylistStatusTypes,
  PlaylistTypes,
} from "../mylist/Columns";
import ChipElement from "../../../util/preview-element/ChipElement";
import { getPlaylistCategories } from "../../../util/SysCalls";
import PlayerRef, { PlayableTypes } from "../../ml-player/PlayerRef/PlayerRef";
import { PlaylistItemTypes } from "../../ml-music-search/track/RecentPlaylistMenu";
// import albumFields from "../../../_module/definition/albumFields";
import HelpWrap from "../../ml-admin/help-admin/help-view/HelpWrap";
import { helpModules } from "../../ml-admin/help-admin/help-view/Const";
import CtagRulePreview from "../../../util/c-tag-util/CtagRulePreview";
// import { _settingAlbumMetadataFieldsDefault } from "../../../_module/definition/SettingAlbumMetadata";
import { getOrgGroups } from "./../../../util/SysCalls";
import {
  showCtagRulePreview,
  emptyCtagRulePreview,
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  setQuery,
  prsSetHistory,
  focusItem,
  CreatePrsTrack,
  CreatePrsManualMatchTrack,
  search,
} from "../../../redux/actions/MlTrackLibraryActions";
import {
  updatePrsData
} from "../../../redux/actions/MlPlaylistContentActions";
import { AuthSrc } from './../../../util/AuthSrc';
import { getContributorDetails, userDisplay } from 'util/CommonFunc';
import { getChangeLogDetails } from './../../../util/CommonFunc';
import OrgUserPlaylistSharedGroups from "util/preview-element/OrgUserPlaylistSharedGroups";
import MetaDataPopOut from "../../../_module/component/metadata-popout/metadata-popout";
import { PageTableType, albumTypes } from "redux/Types";
import { clearDownloads } from "../../../redux/actions/DownloadActions";
import CliIcon from "images/sky-music.png";
import CliIconMain from "images/artwork.png";
import PrsPopup from "_module/component/prs-popup/prs-popup";
import PrsDataPreview from "util/PrsDataPreview";
import {
  getTrafficLightColor,
  getTrafficLightLabel,
} from "_module/component/traffic-light-info-box/traffic-light-info-box";
import { getUserDisplay } from "util/CommonFunc";
import TrackMetadataGrid from "_module/component/track-metadata-grid/track-metadata-grid";
import { DurationDisplayText } from "util/DurationDisplay";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tabpanel-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

class Preview extends Component {
  constructor() {
    super();
    this.state = {
      tabValue: 0,
      orgGroups: null,
      playlistCategories: null,
    };
  }

  componentDidMount() {
    if (this.state.orgGroups === null) {
      getOrgGroups().then((data) => {
        this.setState({ orgGroups: data });
      });
    }

    if (this.state.playlistCategories === null) {
      getPlaylistCategories(PlaylistTypes.public).then((data) => {
        this.setState({ playlistCategories: data });
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      mlTrackData: { showCtagRule },
      data: { selectedItem },
      showCtagRulePreview,
      emptyCtagRulePreview,
      clearDownloads,
    } = this.props;

    if (showCtagRule) {
      this.setState({ tabValue: 2 });
      showCtagRulePreview(false);
    }

    if (prevProps?.data?.selectedItem?.id !== selectedItem?.id) {
      clearDownloads();
    }
  }

  colsDefTrakAll = null;

  generateColsDef(origin, selectedItem) {
    const {
      orgRuntime: {
        runtime: {
          _settingMetadataFieldsDefault: _settingMetadataFieldsDefault,
          _settingAlbumMetadataFieldsDefault:
          _settingAlbumMetadataFieldsDefault,
          _mlMetadata,
          _trackMetadataConfig,
          _albumMetadataConfig,
        },
      },
    } = this.props;
    const metaDataSetting = _PermittedContent(
      [
        _mlMetadata,
        selectedItem.pl_prop_type === PlaylistItemTypes.album
          ? _albumMetadataConfig
          : _trackMetadataConfig,
      ],
      []
    ) || { setting: [] };

    this.colsDefTrakAll =
      _PermittedSetting(
        metaDataSetting.setting,
        selectedItem.pl_prop_type === PlaylistItemTypes.album
          ? _settingAlbumMetadataFieldsDefault
          : _settingMetadataFieldsDefault
      ) || [];
  }

  a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  renderTrackMetadata = (id, i, classes, selectedItem, t, prop) => {
    const {
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
          _trackMusicOrigins: trackOrigins,
        },
      },
    } = this.props;
    let column = trackColumns[id];

    let value =
      selectedItem[id] && Array.isArray(selectedItem[id])
        ? selectedItem[id].join(", ")
        : selectedItem[id];
    return prop.tag ? (
      <div key={i} className={classes.trackTags}>
        <label
          className={
            id === "title" ? classes.trackTabsLabelBold : classes.trackTabsLabel
          }
          title={t(`track.${id}`)}>
          {t(`track.${id}`)}
        </label>
        {selectedItem[id] && Array.isArray(selectedItem[id]) ? (
          selectedItem[id].map((desc, i) => {
            return desc ? <Chip key={i} label={desc} /> : null;
          })
        ) : selectedItem[id] ? (
          <span className={classes.muDetails}>{selectedItem[id]}</span>
        ) : (
          ""
        )}
      </div>
    ) : (
      <div key={i} className={clsx(classes.muDetailWrap, "popupData")}>
        <div
          className={clsx(
            id === "title" ? classes.muLabelsBold : classes.muLabels,
            classes.muLabels
          )}
          title={
            id == "bbcTrackId" &&
              (process.env.REACT_APP_CLIENT_NONBBC ||
                process.env.REACT_APP_CLIENT_NONBBC == true)
              ? t(
                `track.${process.env.REACT_APP_CLIENT_NAME
                  ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                  : "bbc"
                }TrackId`
              )
              : id == "bbcAlbumId" &&
                (process.env.REACT_APP_CLIENT_NONBBC ||
                  process.env.REACT_APP_CLIENT_NONBBC == true)
                ? t(
                  `track.${process.env.REACT_APP_CLIENT_NAME
                    ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                    : "bbc"
                  }AlbumId`
                )
                : prop?.label
                  ? prop?.label
                  : t(`track.${id}`)
          }>
          {id == "bbcTrackId" &&
            (process.env.REACT_APP_CLIENT_NONBBC ||
              process.env.REACT_APP_CLIENT_NONBBC == true)
            ? t(
              `track.${process.env.REACT_APP_CLIENT_NAME
                ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                : "bbc"
              }TrackId`
            )
            : id == "bbcAlbumId" &&
              (process.env.REACT_APP_CLIENT_NONBBC ||
                process.env.REACT_APP_CLIENT_NONBBC == true)
              ? t(
                `track.${process.env.REACT_APP_CLIENT_NAME
                  ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                  : "bbc"
                }AlbumId`
              )
              : prop?.label
                ? prop?.label
                : t(`track.${id}`)}
        </div>
        <div className={classes.muSeperator}> :</div>
        {id === trackFields.prodName.id ? (
          <div
            className={clsx(
              id === trackFields.prodName.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {((selectedItem?.is_mcf_track == true || selectedItem?.mlCreated == true) ?
              <strong class="tablesLink">{value || ""}</strong> :
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                key={selectedItem.id}
                to={`/search/album/${selectedItem.prodId}`}>
                <strong class="tablesLink">{value || ""}</strong>
              </Link>
            )}
          </div>
        ) : id === trackFields.duration.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={DurationDisplayText({ seconds: value }) || ""}>
            {DurationDisplayText({ seconds: value }) || ""}
          </div>
        ) : id == trackFields.contributorsExtended.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {selectedItem.contributorsExtended
              ? getContributorDetails(selectedItem.contributorsExtended)
              : ""}
          </div>
        ) : id == trackFields.changeLog.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {selectedItem.changeLog
              ? getChangeLogDetails(selectedItem.changeLog)
              : ""}
          </div>
        ) : id == trackFields.skyTracfficLight.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={value ? getTrafficLightLabel(value) : "N/A"}>
            <span
              style={{
                backgroundColor: value ? getTrafficLightColor(value) : "",
                width: "22px",
                height: "22px",
                borderRadius: "50%",
                marginRight: "8px",
                display: "inline-block",
                verticalAlign: "middle",
              }}></span>
            {value ? getTrafficLightLabel(value) : "N/A"}
          </div>
        ) : id === trackFields.org_sky_PPL.id ||
          id === trackFields.org_sky_MCPS.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {/* {value == true ? (
              // "Yes"
              "No"
            ) : value == false && id === trackFields.org_sky_MCPS.id ? (
              // <span className={classes.nonMCPSPPL}>Non-MCPS</span>
              <span className={classes.nonMCPSPPL}>Yes</span>
            ) : value == false && id === trackFields.org_sky_PPL.id ? (
              // <span className={classes.nonMCPSPPL}>Non-PPL</span>
              <span className={classes.nonMCPSPPL}>Yes</span>
            ) : (
              ""
            )} */}
           {value == true ? (
              "Yes"
            ) : value == false && id === trackFields.org_sky_MCPS.id ? (
              <span className={classes.nonMCPSPPL}>Non-MCPS</span>
              // <span className={classes.nonMCPSPPL}>Yes</span>
            ) : value == false && id === trackFields.org_sky_PPL.id ? (
              <span className={classes.nonMCPSPPL}>Non-PPL</span>
              // <span className={classes.nonMCPSPPL}>Yes</span>
            ) : (
              ""
            )}
          </div>
        ) : id === trackFields.org_sky_prodIsPPLBlanket.id ||
          id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {value == true ? (
              ""
            ) : value == false && id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
              <span className={classes.nonMCPSPPL}>Non-MCPS</span>
            ) : value == false && id === trackFields.org_sky_prodIsPPLBlanket.id ? (
              <span className={classes.nonMCPSPPL}>Non-PPL</span>
            ) : (
              ""
            )}
          </div>
        ) : trackFields[id] && trackFields[id].linkable ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {value &&
              value.split(",").map((data, i, array) => (
                <Link
                  style={{ textDecoration: "none", color: "#fff" }}
                  key={`${i}_${data}`}
                  aria-label={`Open Link ${t(`track.${id}`)}: ${data}`}
                  title={data}
                  to={{
                    pathname: `/search/tracks/${encodeURI(
                      data.trim().replace("/", "")
                    )}/${id}`,
                    state: {
                      q: `${data.trim()}`,
                      autofocus: false,
                    },
                  }}>
                  <strong class="tablesLink">
                    {data}
                    {i === array.length - 1 ? null : ", "}
                  </strong>
                </Link>
              ))}
          </div>
        ) : (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={
              column?.type === ColumnTypes.datetime ||
                column?.type === ColumnTypes.date
                ? null
                : id === trackFields.musicOrigin.id && value
                  ? t(`modules.originLables.${value}`)
                  : value || ""
            }>
            {column?.type === ColumnTypes.datetime ? (
              value ? (
                <Moment
                  format="DD/MM/YYYY h:mm:ss A"
                  titleFormat="DD/MM/YYYY h:mm:ss A"
                  withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.date ? (
              value ? (
                <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.users ? (
              value ? (
                getUserDisplay(String(value))
              ) : null
            ) : id === trackFields.musicOrigin.id && value ? (
              trackOrigins[value] && trackOrigins[value].label ? (
                trackOrigins[value].label
              ) : trackOrigins["origin" + value] &&
                trackOrigins["origin" + value].label ? (
                trackOrigins["origin" + value].label
              ) : (
                t(`modules.originLables.${value}`)
              )
            ) : id === trackFields.org_sky_prodIsMCPSBlanket.id ||
              id === trackFields.org_sky_prodIsPPLBlanket.id ? (
              <div
                className={clsx(
                  id === trackFields?.prodName?.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {value == true ? (
                  ""
                ) : value == false &&
                  id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                ) : value == false &&
                  id === trackFields.org_sky_prodIsPPLBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                ) : (
                  ""
                )}
              </div>
            ) : id === trackFields.org_sky_MCPS.id ||
              id === trackFields.org_sky_PPL.id ? (
              <div
                className={clsx(
                  id === trackFields?.prodName?.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {value == true ? (
                  "Yes"
                ) : value == false && id === trackFields.org_sky_MCPS.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                  // <span className={classes.nonMCPSPPL}>Yes</span>
                ) : value == false &&
                  id === trackFields.org_sky_PPL.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                  // <span className={classes.nonMCPSPPL}>Yes</span>
                ) : (
                  ""
                )}
              </div>
            ) : id === trackFields.org_sky_prodIsMCPSBlanket.id ||
              id === trackFields.org_sky_prodIsPPLBlanket.id ? (
              <div
                className={clsx(
                  id === trackFields?.prodName?.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {value == true ? (
                  ""
                ) : value == false && id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                ) : value == false &&
                  id === trackFields.org_sky_prodIsPPLBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                ) : (
                  ""
                )}
              </div>
            ) : column?.type === ColumnTypes.boolean ? (
              value || value == true ? (
                "True"
              ) : value == false ? (
                "False"
              ) : (
                ""
              )
            ) : value !== undefined && value !== null ? (
              value
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    );
  };

  renderAlbumMetadata = (id, i, classes, selectedItem, t, prop) => {
    const {
      orgRuntime: {
        runtime: {
          _albumFields: albumFields,
          _albumMusicOrigins: albumOrigins,
        },
      },
    } = this.props;
    let column = albumColumns[id];
    let value =
      selectedItem[id] && Array.isArray(selectedItem[id])
        ? selectedItem[id].join(", ")
        : selectedItem[id];

    let selectedAlbumType;

    if (id === "org_sky_AlbumTypeID") {
      selectedAlbumType = albumTypes.find(
        (type) => type.id === selectedItem.org_sky_AlbumTypeID
      );
    }

    return prop.tag ? (
      <div key={i} className={classes.trackTags}>
        <label
          className={
            id === "title" ? classes.trackTabsLabelBold : classes.trackTabsLabel
          }
          title={t(`album.${id}`)}>
          {t(`album.${id}`)}
        </label>
        {selectedItem[id] && Array.isArray(selectedItem[id])
          ? selectedItem[id].map((desc, i) => {
            return desc ? <Chip key={i} label={desc} /> : null;
          })
          : selectedItem[id]
            ? selectedItem[id]
            : ""}
      </div>
    ) : (
      <div key={i} className={classes.muDetailWrap}>
        <div
          className={clsx(
            id === "title" ? classes.muLabelsBold : classes.muLabels,
            classes.muLabels
          )}
          title={
            id == "bbcAlbumId" &&
              (!process.env.REACT_APP_CLIENT_NONBBC ||
                process.env.REACT_APP_CLIENT_NONBBC == false)
              ? t(
                `album.${process.env.REACT_APP_CLIENT_NAME
                  ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                  : "bbc"
                }AlbumId`
              )
              : id == "bbcTrackId" &&
                (!process.env.REACT_APP_CLIENT_NONBBC ||
                  process.env.REACT_APP_CLIENT_NONBBC == false)
                ? t(
                  `album.${process.env.REACT_APP_CLIENT_NAME
                    ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                    : "bbc"
                  }TrackId`
                )
                : t(`album.${id}`)
          }>
          {id == "bbcAlbumId" &&
            (!process.env.REACT_APP_CLIENT_NONBBC ||
              process.env.REACT_APP_CLIENT_NONBBC == false)
            ? t(
              `album.${process.env.REACT_APP_CLIENT_NAME
                ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                : "bbc"
              }AlbumId`
            )
            : id == "bbcTrackId" &&
              (!process.env.REACT_APP_CLIENT_NONBBC ||
                process.env.REACT_APP_CLIENT_NONBBC == false)
              ? t(
                `album.${process.env.REACT_APP_CLIENT_NAME
                  ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                  : "bbc"
                }TrackId`
              )
              : t(`album.${id}`)}
        </div>

        <div className={classes.muSeperator}> :</div>

        {id === albumFields.prodName.id ? (
          <div
            className={clsx(
              id === albumFields.prodName.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {((selectedItem?.is_mcf_track == true || selectedItem?.mlCreated == true) ?
              <strong class="tablesLink">{value || ""}</strong> :
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                key={selectedItem.id}
                to={`/search/album/${selectedItem.prodId}`}>
                <strong class="tablesLink">{value || ""}</strong>
              </Link>
            )}
          </div>
        ) : id === albumFields.org_sky_IsMCPSBlanket.id ||
          id === albumFields.org_sky_IsPPLBlanket.id ? (
          <div
            className={clsx(
              id === albumFields.prodName.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {value == true ? (
              ""
            ) : value == false &&
              id === albumFields.org_sky_IsMCPSBlanket.id ? (
              <span className={classes.nonMCPSPPL}>Non-MCPS</span>
            ) : value == false && id === albumFields.org_sky_IsPPLBlanket.id ? (
              <span className={classes.nonMCPSPPL}>Non-PPL</span>
            ) : (
              ""
            )}
          </div>
        ) : id === albumFields.org_sky_trackMCPS.id ||
          id === albumFields.org_sky_trackPPL.id ? (
          <div
            className={clsx(
              id === albumFields.prodName.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {value == true ? (
              "Yes"
            ) : value == false &&
              id === albumFields.org_sky_trackMCPS.id ? (
              <span className={classes.nonMCPSPPL}>Non-MCPS</span>
            ) : value == false && id === albumFields.org_sky_trackPPL.id ? (
              <span className={classes.nonMCPSPPL}>Non-PPL</span>
            ) : (
              ""
            )}
          </div>
        ) : // id === albumFields.trackPerformer.id ?
          albumFields[id] && albumFields[id].linkable ? (
            <div
              className={clsx(
                id === "title" ? classes.muDetailsBold : classes.muDetails,
                classes.muDetails
              )}>
              {value &&
                value.split(",").map((data, i, array) => (
                  <Link
                    style={{ textDecoration: "none", color: "#fff" }}
                    key={`${i}_${data}`}
                    aria-label={`Open Link ${t(`album.${id}`)}: ${data}`}
                    title={data}
                    to={{
                      pathname: `/search/albums/${encodeURI(
                        data.trim().replace("/", "")
                      )}/${id}`,
                      state: {
                        q: `${data.trim()}`,
                        autofocus: false,
                      },
                    }}>
                    <strong class="tablesLink">
                      {data}
                      {i === array.length - 1 ? null : ", "}
                    </strong>
                  </Link>
                ))}
            </div>
          ) : (
            <div
              className={clsx(
                id === "title" ? classes.muDetailsBold : classes.muDetails,
                classes.muDetails
              )}
              title={
                column?.type === ColumnTypes.datetime ||
                  column?.type === ColumnTypes.date
                  ? null
                  : id === albumFields.musicOrigin.id && value
                    ? t(`modules.originLables.${value}`)
                    : id === "org_sky_AlbumTypeID"
                      ? selectedAlbumType
                        ? selectedAlbumType.label
                        : ""
                      : value || ""
              }>
              {column?.type === ColumnTypes.datetime ? (
                value ? (
                  <Moment
                    format="DD/MM/YYYY h:mm:ss A"
                    titleFormat="DD/MM/YYYY h:mm:ss A"
                    withTitle>
                    {value}
                  </Moment>
                ) : null
              ) : column?.type === ColumnTypes.date ? (
                value ? (
                  <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>
                    {value}
                  </Moment>
                ) : null
              ) : column?.type === ColumnTypes.users ? (
                value ? (
                  getUserDisplay(String(value))
                ) : null
              ) : id === albumFields.musicOrigin.id && value ? (
                albumOrigins[value] && albumOrigins[value].label ? (
                  albumOrigins[value].label
                ) : albumOrigins["origin" + value] &&
                  albumOrigins["origin" + value].label ? (
                  albumOrigins["origin" + value].label
                ) : (
                  t(`modules.originLables.${value}`)
                )
              ) : column?.type === ColumnTypes.boolean ? (
                Array.isArray(value)
                  ? value.map(v => v == "true" ? "True" : v == "false" ? "False" : v).join(", ")
                  : value == "true"
                    ? "True"
                    : value == "false"
                      ? "False"
                      : value
              ) : id === "org_sky_AlbumTypeID" ? (
                selectedAlbumType ? (
                  selectedAlbumType.label
                ) : (
                  ""
                )
              ) : (
                value || ""
              )}
            </div>
          )}
      </div>
    );
  };

  getIpsText = (ipsArray) => {
    try {
      if (Array.isArray(ipsArray)) {
        return ipsArray
          ?.filter((r) => r?.fullName)
          .map((r) => r?.fullName)
          ?.join(", ");
      } else {
        return null;
      }
    } catch {
      return null;
    }
  };

  renderAdminNotes = (selectedItem, classes, t) => {
    return (
      <>
        <div className={classes.muDetailWrap}>
          <div title="BBC Admin Notes" className={classes.muLabels}>
            {" "}
            BBC Admin Notes{" "}
          </div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcAdminNotes || ""}>
            {selectedItem?.bbcAdminNotes || ""}
          </div>
        </div>
        <div className={classes.muDetailWrap}>
          <div title="BBC Librarian Notes" className={classes.muLabels}>
            {" "}
            BBC Librarian Notes{" "}
          </div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLibrarianNotes || ""}>
            {selectedItem?.bbcLibrarianNotes || ""}
          </div>
        </div>
        <div className={classes.muDetailWrap}>
          <div title="BBC Licence Notes" className={classes.muLabels}>
            {" "}
            BBC Licence Notes{" "}
          </div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLicenceNotes || ""}>
            {selectedItem?.bbcLicenceNotes || ""}
          </div>
        </div>
      </>
    );
  };

  render() {
    let selectedItem;
    const {
      classes,
      data: {
        selectedItem: selectedItemForPreview,
        playlist,
        postUpdating,
        PRSHistoryLoading,
        query,
      },
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
          _albumFields: albumFields,
          _mlMetadata,
          _canSeeAdminNotes,
          _extendedTrackPreviewMetadata,
        },
      },
      allUsers,
      item,
      runtime,
      prsTrackUnlink,
      prsHistorySearch,
      search,
      prsMechanicalOverride,
      prsSetHistory,
      CreatePrsTrack,
      focusItem,
      updatePrsData,
      CreatePrsManualMatchTrack
    } = this.props;

    if (this.props?.isPopOut) {
      selectedItem = item;
    } else {
      selectedItem = selectedItemForPreview;
    }

    if (selectedItem && selectedItem.id)
      this.generateColsDef(
        (selectedItem[trackFields.musicOrigin.id] || "").toLowerCase(),
        selectedItem
      );

    const canViewAdminNotes = _PermittedContent(
      [_mlMetadata, _canSeeAdminNotes],
      []
    )
      ? true
      : false;
    return (
      <Translation>
        {(t, { i18n }) => (
          <Paper className={classes.sideBar} role="contentinfo">
            {selectedItem && selectedItem.id ? (
              <>
                {!this.props?.isPopOut && (
                  <>
                    <Paper className={classes.disFlex}>
                      <h2 className={classes.muTitle}>
                        {selectedItem.pl_prop_type === PlaylistItemTypes.album
                          ? selectedItem.prodName
                          : (selectedItem[trackFields.trackTitle.id] &&
                            Array.isArray(
                              selectedItem[trackFields.trackTitle.id]
                            )
                            ? selectedItem[trackFields.trackTitle.id].join(
                              ", "
                            )
                            : selectedItem[trackFields.trackTitle.id]) ||
                          t("libraryPreview.na")}
                        <span className={classes.muSubTitle}>
                          {selectedItem.pl_prop_type === PlaylistItemTypes.album
                            ? selectedItem.prodArtist
                            : (selectedItem[trackFields.performer.id] &&
                              Array.isArray(
                                selectedItem[trackFields.performer.id]
                              )
                              ? selectedItem[trackFields.performer.id].join(
                                ", "
                              )
                              : selectedItem[trackFields.performer.id]) ||
                            t("libraryPreview.na")}
                        </span>
                      </h2>
                      <HelpWrap config={helpModules.MPLTPWH} />
                      <DownloadLink
                        track={selectedItem}
                        plId={playlist.id}
                        downloadType={PlayableTypes.playlist}
                      />
                      {/* plUserPermission={"test456"} /> */}
                    </Paper>
                    <div style={{ display: "flex" }}>
                      <Paper>
                        <Box
                          className={classes.artworkHolder}
                          tabIndex="-1"
                          p={1}>
                          <Grid
                            container
                            direction="column"
                            alignItems="center"
                            justify="center"
                            tabIndex="-1">
                            {selectedItem[trackFields.prodArtworkUrl.id] ? (
                              <img
                                style={{ height: 240, width: 240 }}
                                src={AuthSrc(
                                  selectedItem[trackFields.prodArtworkUrl.id]
                                )}
                                alt={
                                  selectedItem[trackFields.trackTitle.id] || ""
                                }
                              />
                            ) : (
                              <Grid
                                container
                                direction="column"
                                alignItems="center"
                                justify="center">
                                <img
                                  className={"emptyArtwork"}
                                  style={{ width: 120 }}
                                  src={CliIconMain}
                                  alt="Sky Music"
                                />
                                {/* <MusicNoteIcon style={{ fontSize: 60 }} /> */}
                              </Grid>
                            )}
                          </Grid>
                          {postUpdating ? null : (
                            <PlayerRef
                              className={classes.playTrackButton}
                              key={selectedItem.id}
                              aria-label="Play"
                              item={selectedItem}
                              popoutFor={PageTableType.MYPLAYLIST_TRACKS}
                              plId={playlist.id}
                            />
                          )}
                        </Box>
                      </Paper>
                      <div className={classes.popOutBlock}>
                        {
                          <MetaDataPopOut
                            popoutFor={PageTableType.MYPLAYLIST_TRACKS}
                            data={selectedItem}
                          />
                        }
                        {
                          <PrsPopup
                            prsTrackUnlink={prsTrackUnlink}
                            prsHistorySearch={prsHistorySearch}
                            prsmechanicaloverride={prsMechanicalOverride}
                            PRSHistoryLoading={PRSHistoryLoading}
                            popoutFor={PageTableType.SEARCH_TRACKS}
                            mbTrackData={selectedItem}
                            prsTrackData={selectedItem?.prsTrack}
                            updatePrsData={updatePrsData}
                            // trackSearch={() => {
                            //   search(query);
                            // }}
                            prsSetHistory={prsSetHistory}
                            // focusItem={focusItem}
                            CreatePrsTrack={CreatePrsTrack}
                            mlsearch={search}
                            CreatePrsManualMatchTrack={CreatePrsManualMatchTrack}
                          />
                        }
                      </div>
                    </div>
                  </>
                )}

                <AppBar className={classes.trackTabsHeader} position="static">
                  <Tabs
                    value={this.state.tabValue}
                    onChange={this.handleTabChange}
                    scrollButtons="auto"
                    variant="scrollable">
                    <Tab
                      label={`${selectedItem.pl_prop_type === PlaylistItemTypes.album
                        ? "Album"
                        : this.props.isPopOut ? "" : "Track"
                        } Metadata`}
                      {...this.a11yProps(0)}
                    />
                    {selectedItem.pl_prop_type === PlaylistItemTypes.track &&
                      _extendedTrackPreviewMetadata &&
                      _extendedTrackPreviewMetadata.prsMetadata != null && (
                        <Tab label="PRS" {...this.a11yProps(1)} value={1} />
                      )}
                    <Tab label="Playlist" {...this.a11yProps(2)} />
                    <Tab label="C-Tag Rules" {...this.a11yProps(3)} />
                  </Tabs>
                </AppBar>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={0}>
                  {/* {!this.props?.isPopOut ?
                    <Paper className={classes.paperwrap}>
                      <div className={clsx(classes.muListWrap, 'popupWindow')}>
                        {this.colsDefTrakAll?.map((id, i) => {
                          const prop =
                            (selectedItem.pl_prop_type === PlaylistItemTypes.album
                              ? albumFields[id]
                              : trackFields[id]) || {};
                          if (
                            selectedItem.pl_prop_type === PlaylistItemTypes.album
                          ) {
                            return this.renderAlbumMetadata(
                              id,
                              i,
                              classes,
                              selectedItem,
                              t,
                              prop
                            );
                          } else {
                            return this.renderTrackMetadata(
                              id,
                              i,
                              classes,
                              selectedItem,
                              t,
                              prop
                            );
                          }
                        })}
                        {canViewAdminNotes &&
                          this.renderAdminNotes(selectedItem, classes, t)}
                        <TextElement
                          label="Chart Position"
                          classes={classes}
                          data={selectedItem?.pl_prop_chartNumber ?? ""}
                        />
                        <DateTimeElement
                          label="Chart Date"
                          classes={classes}
                          data={selectedItem?.pl_prop_chartDate ?? ""}
                          columnType={ColumnTypes.date}
                        />
                        <ChipElement
                          label="Tags"
                          classes={classes}
                          data={selectedItem?.pl_prop_tags ?? []}
                        />
                        <TextElement
                          label="Notes"
                          classes={classes}
                          data={selectedItem?.pl_prop_notes ?? ""}
                        />
                      </div>
                    </Paper>
                    :
                    (<TrackMetadataGrid data={item} classes={classes} />)
                  } */}

                  {this.props?.isPopOut && selectedItem.pl_prop_type !== PlaylistItemTypes.album ?
                    (<TrackMetadataGrid data={item} classes={classes} />)
                    :
                    <Paper className={classes.paperwrap}>
                      <div className={clsx(classes.muListWrap, 'popupWindow')}>
                        {this.colsDefTrakAll?.map((id, i) => {
                          const prop =
                            (selectedItem.pl_prop_type === PlaylistItemTypes.album
                              ? albumFields[id]
                              : trackFields[id]) || {};
                          if (
                            selectedItem.pl_prop_type === PlaylistItemTypes.album
                          ) {
                            return this.renderAlbumMetadata(
                              id,
                              i,
                              classes,
                              selectedItem,
                              t,
                              prop
                            );
                          } else {
                            return this.renderTrackMetadata(
                              id,
                              i,
                              classes,
                              selectedItem,
                              t,
                              prop
                            );
                          }
                        })}
                        {canViewAdminNotes &&
                          this.renderAdminNotes(selectedItem, classes, t)}
                        <TextElement
                          label="Chart Position"
                          classes={classes}
                          data={selectedItem?.pl_prop_chartNumber ?? ""}
                        />
                        <DateTimeElement
                          label="Chart Date"
                          classes={classes}
                          data={selectedItem?.pl_prop_chartDate ?? ""}
                          columnType={ColumnTypes.date}
                        />
                        <ChipElement
                          label="Tags"
                          classes={classes}
                          data={selectedItem?.pl_prop_tags ?? []}
                        />
                        <TextElement
                          label="Notes"
                          classes={classes}
                          data={selectedItem?.pl_prop_notes ?? ""}
                        />
                      </div>
                    </Paper>
                  }

                </TabPanel>
               {selectedItem.pl_prop_type === PlaylistItemTypes.track?
               <TabPanel
               className={classes.trackTabs}
               value={this.state.tabValue}
               index={1}>
               <Paper className={classes.paperwrap}>
                 <div className={clsx(classes.muListWrap, "popupWindow")}>
                   <PrsDataPreview
                     classes={classes}
                     selectedItem={selectedItem}
                   />
                 </div>
               </Paper>
             </TabPanel> : null
               } 
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={selectedItem.pl_prop_type === PlaylistItemTypes.album? 1 : 2}>
                  <Paper className={classes.paperwrap}>
                    <div className={clsx(classes.muListWrap, "popupWindow")}>
                      <TextElement
                        label="Title"
                        classes={classes}
                        showCustomTitle={true}
                        customTitle={playlist?.name}
                        data={playlist?.name}
                      />
                      <DateTimeElement
                        label="Release Date"
                        classes={classes}
                        data={playlist?.releaseDate}
                        columnType={ColumnTypes.date}
                      />
                      <TextElement
                        label="Type"
                        classes={classes}
                        data={
                          playlist[
                            (runtime &&
                              runtime?._config &&
                              runtime?._config?.MIGRATED_FLAG) ||
                            "skyMigrated"
                          ]
                            ? MigratedPlaylistTypesList.find(
                              (d) => d.id == playlist.mlData.projectType
                            )?.value || playlist.mlData.projectType
                            : selectedItem.type === PlaylistTypes.public
                              ? "Promoted"
                              : selectedItem.type === PlaylistTypes.private
                                ? "Standard"
                                : null
                        }
                      />
                      <TextElement
                        label="Items"
                        classes={classes}
                        data={playlist?.itemsCount}
                      />
                      <TextElement
                        label="Priority"
                        classes={classes}
                        data={playlist?.priority}
                      />
                      <TextElement
                        label="Category"
                        classes={classes}
                        data={
                          this.state.playlistCategories?.find(
                            (p) => Number(p.id) === playlist?.categoryId
                          )?.name ?? playlist?.categoryId
                        }
                      />
                      <OrgUserPlaylistSharedUsers
                        label="Shared Users"
                        classes={classes}
                        data={(playlist?.users || []).concat(
                          playlist?.mlData?.sharedUsers || []
                        )}
                        allUsers={allUsers}
                      />
                      <OrgUserPlaylistSharedGroups
                        label="Shared Groups"
                        classes={classes}
                        data={(playlist?.groups || []).concat(
                          playlist?.mlData?.userGroups || []
                        )}
                        orgGroups={this.state.orgGroups}
                      />
                      <ChipElement
                        label="Tags"
                        classes={classes}
                        data={playlist?.tags ?? []}
                      />
                      <TextElement
                        label="Notes"
                        classes={classes}
                        data={playlist?.notes}
                      />
                      <TextElement
                        label="Created By"
                        classes={classes}
                        data={
                          playlist[
                            (runtime &&
                              runtime?._config &&
                              runtime?._config?.MIGRATED_FLAG) ||
                            "skyMigrated"
                          ]
                            ? playlist?.mlData?.createdByName
                            : userDisplay(playlist?.createdBy)
                          // allUsers?.find(
                          //   (p) => p.id === playlist?.createdBy
                          // )?.name ?? playlist?.createdBy
                        }
                      />
                      <DateTimeElement
                        label="Date Created"
                        classes={classes}
                        data={
                          playlist[
                            (runtime &&
                              runtime?._config &&
                              runtime?._config?.MIGRATED_FLAG) ||
                            "skyMigrated"
                          ]
                            ? playlist?.mlData?.createdAt
                            : playlist?.createdAt
                        }
                      />
                      <TextElement
                        label="Edited By"
                        classes={classes}
                        data={
                          playlist[
                            (runtime &&
                              runtime?._config &&
                              runtime?._config?.MIGRATED_FLAG) ||
                            "skyMigrated"
                          ]
                            ? playlist?.mlData?.updatedByName
                            : userDisplay(playlist?.updatedBy)
                          // allUsers?.find(
                          //   (p) => p.id === playlist?.updatedBy
                          // )?.name ?? playlist?.updatedBy
                        }
                      />
                      <DateTimeElement
                        label="Date Edited"
                        classes={classes}
                        data={
                          playlist[
                            (runtime &&
                              runtime?._config &&
                              runtime?._config?.MIGRATED_FLAG) ||
                            "skyMigrated"
                          ]
                            ? playlist?.mlData?.updatedAt
                            : playlist.updatedAt
                        }
                      />
                      <TextElement
                        label="Status"
                        classes={classes}
                        data={
                          playlist?.status === PlaylistStatusTypes.active
                            ? "Active"
                            : playlist?.status === PlaylistStatusTypes.archived
                              ? "Archived"
                              : null
                        }
                      />
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={selectedItem.pl_prop_type === PlaylistItemTypes.album? 2 : 3}>
                {this.props.isPopOut? <CtagRulePreview  classes={this.props.isPopOut? classes : null} /> : <CtagRulePreview />}
                </TabPanel>
              </>
            ) : (
              <div className={classes.noData}>
                {/* <MusicNoteIcon style={{ fontSize: 60, marginBottom: 20 }} /> */}
                <img
                  className={"emptyArtwork"}
                  style={{ width: 120 }}
                  src={CliIcon}
                  alt="Sky Music"
                />
                {/* {t("libraryPreview.noPreview")} */}
              </div>
            )}
          </Paper>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mlplaylistcontent,
  mlTrackData: state.mltracklibrary,
  allUsers: state.inbox.allUsers,
  orgRuntime: state.orgRuntime,
  runtime: state.clearanceRuntime,
});

export default connect(mapStateToProps, {
  showCtagRulePreview,
  emptyCtagRulePreview,
  clearDownloads,
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  prsSetHistory,
  CreatePrsTrack,
  focusItem,
  setQuery,
  updatePrsData,
  CreatePrsManualMatchTrack,
  search,
})(withStyles(styles)(Preview));
